<script>

	// Import the router component
  	import router from 'page';
	// Import the list of routes
	import About from "./routes/About.svelte";
	import Credits from "./routes/Credits.svelte";
	import Main from "./routes/Main.svelte";
	import LGrid from "./routes/LGrid.svelte";

	let page;

	router('/', () => page = Main)
	router('/about', () => page = About)
	router('/credits', () => page = Credits)
	router('/lgrid', () => page = LGrid)
	
	router.start()

	let winW = 520;
	let minW = 520;

	winW = window.outerWidth;

</script>


<svelte:head>
	{#if winW > minW }
		<meta name='viewport' content='width=device-width,initial-scale=1'>
	{:else}
		<meta name="viewport" content="width=520,initial-scale={winW / minW}">
	{/if}
</svelte:head>

<main>

	<svelte:component this="{page}" />

</main>

<style>

</style>